import axios from './axios';

/**
 * Load PayPal SDK script
 * @param {Object} settings - PayPal settings
 * @returns {Promise} Promise that resolves when SDK is loaded
 */
export const loadPayPalScript = async (settings) => {
    return new Promise((resolve, reject) => {
        if (window.paypal) {
            console.log('PayPal SDK already loaded');
            resolve();
            return;
        }

        // Remove any existing PayPal scripts
        const existingScripts = document.querySelectorAll('script[src*="paypal.com/sdk"]');
        existingScripts.forEach(script => script.remove());

        // Clear any existing global PayPal object
        window.paypal = null;

        const script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=${settings.clientId}&currency=GBP`;
        script.async = true;
        script.crossOrigin = 'anonymous';

        script.onload = () => {
            if (window.paypal) {
                console.log('PayPal SDK loaded successfully');
                resolve();
            } else {
                reject(new Error('PayPal SDK loaded but window.paypal is not available'));
            }
        };

        script.onerror = (error) => {
            console.error('Error loading PayPal SDK:', error);
            reject(new Error('Failed to load PayPal SDK'));
        };

        document.body.appendChild(script);
    });
};

/**
 * Get PayPal settings from the server
 * @returns {Promise} - A promise that resolves with the PayPal settings
 */
export const getPayPalSettings = async () => {
    try {
        console.log('Fetching PayPal settings from server');
        const response = await axios.get('/api/settings/payment');
        console.log('Received PayPal settings:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching PayPal settings:', error);
        throw error;
    }
};

/**
 * Initialize PayPal button
 * @param {string} containerId - ID of the container element
 * @param {Object} buttonConfig - PayPal button configuration
 * @returns {Promise} Promise that resolves with the button instance
 */
export const initializePayPalButton = async (containerId, buttonConfig) => {
    console.log('Initializing PayPal button in container:', containerId);

    const container = document.getElementById(containerId);
    if (!container) {
        throw new Error(`Container element with ID ${containerId} not found`);
    }

    // Clear container
    container.innerHTML = '';

    if (!window.paypal || !window.paypal.Buttons) {
        throw new Error('PayPal SDK or Buttons API not available');
    }

    try {
        const button = window.paypal.Buttons(buttonConfig);
        await button.render(`#${containerId}`);
        console.log('PayPal button rendered successfully');
        return button;
    } catch (err) {
        console.error('Error rendering PayPal button:', err);
        throw new Error('Failed to render PayPal button');
    }
}; 